import type { Instance } from 'tippy.js';

export const hideOnEsc = {
  name: 'hideOnEsc',
  defaultValue: true,
  fn(instance: Instance): { onShow: () => void; onHide: () => void } {
    function onKeyUp(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        instance.hide();
      }
    }

    return {
      onShow() {
        document.addEventListener('keyup', onKeyUp);
      },
      onHide() {
        document.removeEventListener('keyup', onKeyUp);
        if (instance.reference !== null) {
          (instance.reference as HTMLButtonElement).focus();
        }
      },
    };
  },
};
